import Mark from 'mark.js';

export default {

    scrollIntoView(selectedHighlight) {
        if (selectedHighlight == -1 || selectedHighlight == undefined) return;
        let contentElement = document.querySelector(".content");
        var highlightElements = [...contentElement.getElementsByClassName("highlight")];
        var element = highlightElements.find(x => -1 < x.dataset.highlightId.indexOf(selectedHighlight.toString()));

        if (element && !this.isElementVisible(element)) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },

    isElementVisible(el) {

        if (el === undefined) return false;

        var rect = el.getBoundingClientRect(),
            vWidth = window.innerWidth || document.documentElement.clientWidth,
            vHeight = window.innerHeight || document.documentElement.clientHeight,
            efp = function (x, y) { return document.elementFromPoint(x, y) };

        // Return false if it's not in the viewport
        if (rect.right < 0 || rect.bottom < 0 ||
            rect.left > vWidth || rect.top > vHeight)
            return false;

        // Return true if any of its four corners are visible
        return (
            el.contains(efp(rect.left, rect.top)) ||
            el.contains(efp(rect.right, rect.top)) ||
            el.contains(efp(rect.right, rect.bottom)) ||
            el.contains(efp(rect.left, rect.bottom))
        );
    },

    updateMarkersHOCR(rootElement, selectedHighlight = -1) {
        var contentElement = rootElement.getElementsByClassName("content");
        var documentHtml = rootElement.getElementById("main-document-view");
        var highlightElements = [...documentHtml.getElementsByClassName("highlight")];
        var markers = documentHtml.getElementsByClassName("marker");

        if (highlightElements === undefined || highlightElements.length === 0)
            return;

        var scrollOffset = contentElement.length > 0 ? contentElement[0].scrollTop : 0;
        var parentTop = documentHtml.offsetTop - scrollOffset;
        var parentHeight = documentHtml.offsetHeight;

        var highlightedId = "";

        Array.from(markers).forEach((marker, i) => {

            //Find correct wild highlight element.
            var highlightElement = highlightElements.find(x => -1 < x.dataset.highlightId.indexOf(i.toString()));

            if (highlightElement === undefined)
                return;

            var wildRect = highlightElement.getBoundingClientRect();
            var y = Math.min(Math.max(wildRect.top - parentTop, 0), parentHeight);
            marker.style.top = y + "px";

            if ((y >= parentHeight || y <= 0 || (i !== selectedHighlight && selectedHighlight != -1)) && (highlightedId !== highlightElement.dataset.highlightId)) {
                marker.style.visibility = "hidden";
            }
            else {
                highlightedId = highlightElement.dataset.highlightId;
                marker.style.visibility = "visible";
            }
        });
    },

    /* ### PRINT ### */
    print(document, element) {
        if (!element) element = document.getElementsByClassName('document-view')[0];
        let frameId = "test";

        // To prevent duplication and issues, remove any used printFrame from the DOM
        const usedFrame = document.getElementById(frameId);
        if (usedFrame) usedFrame.parentNode.removeChild(usedFrame);

        // Clone the target element including its children (if available)
        let clonedElement = this.deepCloneWithStyles(document, element);

        const printFrame = document.createElement('iframe');
        printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 21cm; position: absolute; border: 0');
        printFrame.setAttribute('id', frameId);

        printFrame.onload = () => {

            // Get iframe element document
            const iframeElement = printFrame;
            let printDocument = (iframeElement.contentWindow || iframeElement.contentDocument);
            if (printDocument.document) printDocument = printDocument.document;

            // Append printable element to the iframe body
            printDocument.body.appendChild(clonedElement);
            printDocument.body.setAttribute('style', 'margin: 0');

            //this.updateMarkers(printDocument);
            // iframeElement.contentWindow.print();

            // Wait for images to load inside the iframe
            const images = printDocument.querySelector('g.images');

            if (images.children.length > 0) {
                this.loadIframeImages(Array.from(images.children)).then(() => this.performPrint(iframeElement))
            } else {
                this.performPrint(iframeElement)
            }
        }

        // Append iframe element to document body
        let body = document.getElementsByTagName('body')[0];
        body.appendChild(printFrame);
    },

    performPrint(iframeElement) {
        try {
            iframeElement.contentWindow.print();
        } catch (e) {
            iframeElement.contentWindow.document.execCommand('print', false, null);
        }
    },

    loadIframeImages(images) {
        const promises = images.map(image => {
            if (image.src && image.src !== window.location.href) {
                return this.loadIframeImage(image)
            }
        })

        return Promise.all(promises)
    },

    loadIframeImage(image) {
        return new Promise(resolve => {
            const pollImage = () => {
                !image || typeof image.naturalWidth === 'undefined' || image.naturalWidth === 0 || !image.complete
                    ? setTimeout(pollImage, 500)
                    : resolve()
            }
            pollImage()
        })
    },

    deepCloneWithStyles(document, node) {
        const clone = node.cloneNode(false);

        if (clone.style)
            clone.setAttribute('style', this.collectStyles(document, node));

        for (let child of node.childNodes)
            clone.appendChild(this.deepCloneWithStyles(document, child));

        return clone;
    },

    collectStyles(document, element) {

        if (element.nodeType !== Node.ELEMENT_NODE) return "";

        const win = document.defaultView || window;
        let elementStyle = '';

        // Loop over computed styles
        const styles = win.getComputedStyle(element, '');
        const unacceptedStyles = this.getUnacceptedStyles(element);
        const acceptedStyles = this.getAcceptedStyles(element);

        // Check if style should be processed.
        for (let key = 0; key < styles.length; key++) {
            if ((acceptedStyles.includes('*') || acceptedStyles.indexOf(styles[key]) != -1) && unacceptedStyles.indexOf(styles[key]) == -1) {
                if (styles.getPropertyValue(styles[key])) elementStyle += styles[key] + ':' + styles.getPropertyValue(styles[key]) + ';';
            }
        }

        // Add print friendly styles.
        elementStyle += this.getPrintStyles(element);

        return elementStyle;
    },

    getUnacceptedStyles(element) {
        if (element.nodeType !== Node.ELEMENT_NODE || !element.classList) return [];

        const unacceptedStyles = {
            'marker': ['visibility'],
            'document-view': ['width'],
            'box': ['opacity']
        }

        let result = [];
        let values = Object.keys(element.classList).map(function (i) { return element.classList[i]; }); //Instead of element.classList.values()
        for (var className of values) {
            if (unacceptedStyles.hasOwnProperty(className))
                result = result.concat(unacceptedStyles[className]);
        }

        return result;
    },

    getAcceptedStyles(element) {
        if (element.nodeType !== Node.ELEMENT_NODE || !element.classList) return [];

        const acceptedStyles = {
            '*': [],
            'marker': ['width', 'height', 'background-color', 'top', 'position', 'border-top-left-radius', 'border-top-right-radius',
                'border-bottom-left-radius', 'border-bottom-right-radius', 'border', 'display', 'vertical-align', 'pointer-events', 'fill',
                'stroke', 'stroke-width', 'opacity'],
            'rects': ['fill', 'stroke', 'stroke-opacity', 'stroke-dasharray', 'stroke-width', 'opacity', 'pointer-events'],
            'ocr_carea': ['fill', 'stroke', 'stroke-opacity', 'stroke-dasharray', 'stroke-width', 'opacity', 'pointer-events'],
            'ocr_par': ['fill', 'stroke', 'stroke-opacity', 'stroke-dasharray', 'stroke-width', 'opacity', 'pointer-events'],
            'ocr_line': ['fill', 'stroke', 'stroke-opacity', 'stroke-dasharray', 'stroke-width', 'opacity', 'pointer-events'],
            'ocrx_word': ['fill', 'stroke', 'stroke-opacity', 'stroke-dasharray', 'stroke-width', 'opacity', 'pointer-events'],
            'highlight': ['text-decoration', 'background-color', 'color-adjust', '-webkit-print-color-adjust', 'print-color-adjust'],
            'document-view': [],
            'document-html': ['padding-left'],
            // 'export-texts': ['page-break-before'],
            'position': ['float'],
            'box': ['margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-color',
                'border-top-style', 'border-top-width', 'border-right-color', 'border-right-style',
                'border-right-width', 'border-bottom-color', 'border-bottom-style', 'border-bottom-width',
                'border-left-color', 'border-left-style', 'border-left-width', 'border-top-left-radius', 'border-top-right-radius',
                'border-bottom-left-radius', 'border-bottom-right-radius', 'box-shadow'
            ],
            'box-header': ['margin-bottom'],
            'title': ['margin-left', 'font-size'],
            'section': ['border-left-color', 'border-left-width', 'border-left-style', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'margin-top'],
            'export-texts': ['page-break-before', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
            'highlight-text': ['background-color', 'color', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',
                'border-left-style', 'border-left-width', 'border-top-left-radius', 'border-top-right-radius', 'border-bottom-left-radius', 'border-bottom-right-radius', 'width'],
            'layout': ['display', 'margin', 'background-color', 'box-sizing', 'border', 'box-shadow', 'background']
        }

        let result = [];
        let values = Object.keys(element.classList).map(function (i) { return element.classList[i]; }); //Instead of element.classList.values()
        for (var className of values) {
            if (acceptedStyles.hasOwnProperty(className))
                result = result.concat(acceptedStyles[className]);
        }

        return result;
    },

    getPrintStyles(element) {
        if (element.nodeType !== Node.ELEMENT_NODE || !element.classList) return [];

        const printStyles = {
            'document-html': "page-break-after: always",
            'box': "page-break-inside: avoid",
            'highlight-text': "color-adjust: exact; -webkit-print-color-adjust: exact; print-color-adjust: exact"
        }

        let result = [];
        let values = Object.keys(element.classList).map(function (i) { return element.classList[i]; }); //Instead of element.classList.values()
        for (var className of values) {
            if (printStyles.hasOwnProperty(className))
                result += printStyles[className] + ';';
        }

        return result;
    },

    /* ### HIGHLIGHT ### */
    highlight(highlights, element, onDone = () => { }) {
        let markInstance = new Mark(element);
        this.unmarkText(markInstance, "highlight");

        if (highlights === undefined || highlights.length === 0)
            return;

        for (var i in highlights) {
            var item = highlights[i];
            let isActiveClass = item.isActive ? "" : " disabled";

            var textSegment = {
                text: item.text,
                start: item.startPosition,
                length: item.endPosition - item.startPosition,
                className: `highlight risk-${item.risk} ${item.category}${isActiveClass}`,
                index: i
            };

            this.toggleHighlighting(markInstance, textSegment, onDone);
        }
    },

    toggleHighlighting(markInstance, textSegment, onDone = () => { }) {

        if (textSegment === undefined) return;
        this.markText(markInstance, textSegment, onDone);
    },

    markText(markInstance, textSegment, onDone = () => { }) {
        if (textSegment === undefined) return;

        var addHighlightId = (element) => {
            element.setAttribute('data-highlight-id', textSegment.index);
        };

        var onNoMatch = (result) => {
            var a = 0;
        };

        var options = {
            "className": textSegment.className,
            "separateWordSearch": false,
            "done": onDone,
            "each": addHighlightId,
            "noMatch": onNoMatch,
            "debug": true
        };

        markInstance.markRanges([textSegment], options);
    },

    unmarkText(markInstance, highlightClass, onDone = () => { }) {
        if (!markInstance) return;

        var options = {
            "className": highlightClass,
            done: onDone
        };
        markInstance.unmark(options);
    },

    highlightTextSegments(highlights, element) {
        if (!element) return;
        //let dataStr = sessionStorage.getItem('documentData');
        //const json = JSON.parse(dataStr);
        //console.log("json.predictedSegments: " + json.predictedSegments);
        console.log("Will highlight text segments.");

        //TODO: Handle multiple highlights for same sentence (multiple categories for one sentence).

        for (var i in highlights) {
            var highlight = highlights[i];
            for (const elementIdKey in highlight.elementIds) {
                let elementId = highlight.elementIds[elementIdKey];
                if (elementId.includes("word")) {
                    let wordTag = element.querySelector("#" + elementId);
                    if (!wordTag) continue;
                    //console.log("Will highlight: " + elementId);

                    if (!wordTag.classList.contains("highlight")) {
                        wordTag.classList.add("highlight");
                        wordTag.classList.add(`risk-${highlight.risk}`);
                        if (highlight.category)
                            wordTag.classList.add(highlight.category);
                        wordTag.classList.add(highlight.id);
                        wordTag.setAttribute('data-highlight-id', i);
                    } else {
                        let id = wordTag.getAttribute('data-highlight-id');
                        wordTag.setAttribute('data-highlight-id', id + "," + i);
                    }

                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/helpers/documentViewer.js